export default __webpack_public_path__ + "static/WorkSans-Medium-a95fc1b0412a546c0b19eaf985bf1075.ttf";